module.exports = __webpack_public_path__ + "media/6.3cfccfd6.mp3";